/** @file entryCardMenu: a project or puppet card's right-click menu (Open/Rename/Trash, Restore/Purge). */
import type { MenuItem } from '../state/editorTypes';

/** What the menu can do to the card's project or puppet. */
export type EntryCardActions = { open: () => void; rename: () => void; trash: () => void; restore: () => void; purge: () => void };

/** Live entries: Open, Rename, separator, Move to trash. Trashed ones: Restore, separator, Purge (asks first). */
export function entryCardMenu(trashed: boolean, a: EntryCardActions): MenuItem[] {
  if (trashed) {
    return [
      { kind: 'item', label: 'Restore', onSelect: a.restore },
      { kind: 'separator' },
      { kind: 'item', label: 'Purge for good...', onSelect: a.purge },
    ];
  }
  return [
    { kind: 'item', label: 'Open', onSelect: a.open },
    { kind: 'item', label: 'Rename...', onSelect: a.rename },
    { kind: 'separator' },
    { kind: 'item', label: 'Move to trash', onSelect: a.trash },
  ];
}
